module.exports = __webpack_public_path__ + "static/media/logo.6568fa4d.svg";